import { useState, useEffect } from 'react';
import { $getSelection, $isRangeSelection, $isTextNode } from 'lexical';
import { $patchStyleText } from '@lexical/selection';
import { useRichTextEditor } from '../RichTextEditorProvider';
import { colors } from '@sweep-io/sweep-design';
import { ColorPicker } from '../../color-picker/ColorPicker';
import { SmallColorSwatchButton } from '../../color-picker/SmallColorSwatchButton';

const DEFAULT_TEXT_COLOR = colors.grey[700];

export const TextColorButton = () => {
  const { editor } = useRichTextEditor();
  const [currentColor, setCurrentColor] = useState<string>(DEFAULT_TEXT_COLOR);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          // Get the color from the selected text
          const nodes = selection.getNodes();
          if (nodes.length > 0) {
            const node = nodes[0];
            if ($isTextNode(node)) {
              const style = node.getStyle();
              const colorMatch = style.match(/color:\s*([^;]+)/);
              if (colorMatch) {
                setCurrentColor(colorMatch[1].trim());
              } else {
                setCurrentColor(DEFAULT_TEXT_COLOR);
              }
            }
          }
        }
      });
    });
  }, [editor]);

  const handleColorChange = (color: string) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, {
          color: color,
        });
      }
    });
    setCurrentColor(color);
    setAnchorEl(null);
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  return (
    <>
      <SmallColorSwatchButton
        color={currentColor}
        onClick={handleButtonClick}
        pressed={!!anchorEl}
      />
      {anchorEl && (
        <ColorPicker
          anchorElement={anchorEl}
          closePopover={() => setAnchorEl(null)}
          onColorChange={handleColorChange}
          selectedColor={currentColor}
          position="top"
          singleRow
          palette="dark"
        />
      )}
    </>
  );
};
